// src/config/chartConfig.js
import {
    Chart as ChartJS,
    ArcElement, BarElement, LineElement, PointElement,
    CategoryScale, LinearScale, Title, Tooltip, Legend, Filler
} from "chart.js";

ChartJS.register(
    ArcElement, BarElement, LineElement, PointElement,
    CategoryScale, LinearScale, Title, Tooltip, Legend, Filler
);
